import { LastMessageSystem } from '@halo/ui-chat-react';
import type { MsgGroupRemoveMemberContentProps } from './msg-group-remove-member-content';
import { MsgGroupRemoveMemberContent } from './msg-group-remove-member-content';

export interface MsgGroupRemoveMemberPreviewProps extends MsgGroupRemoveMemberContentProps {}

export const MsgGroupRemoveMemberPreview = memo(function MsgGroupRemoveMemberPreview({
  message,
}: MsgGroupRemoveMemberPreviewProps) {
  return (
    <LastMessageSystem>
      <MsgGroupRemoveMemberContent message={message} />
    </LastMessageSystem>
  );
});
